import { useRef, useState } from "react";
import { draftPatch } from "../services/crmDraft";
import { Alert, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Stack } from "@mui/material";

function SeguimientoForm({ store, oportunidad, onClose }) {
  const base = useRef(oportunidad);
  const [error, setError] = useState("");
  const submit = e => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const nota = String(data.get("nota") || "").trim();
    const tipo = data.get("tipo");
    const proximaAccion = String(data.get("proximaAccion") || "").trim();
    const proximoSeguimiento = data.get("proximoSeguimiento") || null;
    let patch;
    try {
      patch = draftPatch(base.current, { ...base.current, proximaAccion, proximoSeguimiento },
        store.oportunidadesExpansion.find(item => item.id === oportunidad.id));
    } catch (e) { setError(e.message); return; }
    if (nota) store.agregarContacto(oportunidad.leadId, { tipo, nota, opportunityId: oportunidad.id });
    store.editarOportunidad(oportunidad.id, {
      ...(nota ? { ultimoContacto: new Date().toISOString() } : {}),
      ...patch,
    });
    if (nota) store.agregarTarea({
      leadId: oportunidad.leadId, opportunityId: oportunidad.id,
      descripcion: "[" + oportunidad.nombre + "] " + nota.slice(0, 80),
      tipo: tipo === "llamada" ? "llamada" : tipo === "visita" ? "visita" : "seguimiento",
      fechaProgramada: proximoSeguimiento || undefined,
    });
    onClose();
  };
  return <form onSubmit={submit}>
    <DialogContent>
      {error && <Alert severity="warning">{error}</Alert>}
      <Stack spacing={2} mt={1}>
        <TextField name="tipo" select label="Tipo" defaultValue="whatsapp" fullWidth size="small">
          <MenuItem value="whatsapp">WhatsApp</MenuItem><MenuItem value="llamada">Llamada</MenuItem>
          <MenuItem value="presencial">Reunión / presencial</MenuItem><MenuItem value="visita">Visita</MenuItem>
          <MenuItem value="otro">Nota</MenuItem>
        </TextField>
        <TextField name="nota" label="Nota" defaultValue="" multiline rows={3} fullWidth size="small" autoFocus />
        <TextField name="proximaAccion" label="Próxima acción" defaultValue={base.current.proximaAccion || ""} fullWidth size="small" />
        <TextField name="proximoSeguimiento" label="Próximo seguimiento" type="date" defaultValue={base.current.proximoSeguimiento || ""}
          InputLabelProps={{ shrink: true }} fullWidth size="small" />
      </Stack>
    </DialogContent>
    <DialogActions><Button onClick={onClose}>Cancelar</Button><Button variant="contained" type="submit">Registrar</Button></DialogActions>
  </form>;
}
export default function OportunidadSeguimientoDialog({ open, onClose, store, oportunidad }) {
  return <Dialog open={open && Boolean(oportunidad)} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle fontWeight={700}>Seguimiento — {oportunidad?.nombre}</DialogTitle>
    {open && oportunidad && <SeguimientoForm key={oportunidad.id} store={store} oportunidad={oportunidad} onClose={onClose} />}
  </Dialog>;
}
